import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";
import Cookies from "js-cookie";

export const FCMTokenInsert = createAsyncThunk("FCMTokenInsert", async (data) => {
  const url = baseUrl + "FCMTokenInsert";
  const token = Cookies.get("token");

  try {
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const response = res.data;
   
    if (response.status === "success") {
   
      return response.data;
    } else {
      return Promise.reject(response);
    }
  } catch (err) {
    console.error("chat API Error", err);
    return Promise.reject(err);
  }
});



export const sendMessageBack = createAsyncThunk("sendMessageBack", async (data) => {
  const url = baseUrl + "sendMessage";
  const token = Cookies.get("token");

  try {
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const response = res.data;
   
    if (response.status === "success") {
   
      return response.data;
    } else {
      return Promise.reject(response);
    }
  } catch (err) {
    console.error("chat API Error", err);
    return Promise.reject(err);
  }
});

